import React, { useState, useEffect } from "react";
import "./Grammer.css";
import Tolbar from "../Tolbar/Tolbar";
import { MDBCard, MDBCardImage, MDBCardBody, MDBCardTitle, MDBRow, MDBCol } from "mdb-react-ui-kit";
import GrammerDetais from "../Grammer/GrammerDetais";
import Spinner from "./Spinner";
// import axios from "axios";
// import Spinner from "./Spinner";
const Grammer = () => {
  const [grammerMap, SetGrammerMap] = useState();
  const [loading, setLoading] = useState(false);
  const handleClick = () => {
    setLoading(true);
    fetch("https://zabanamooz.herokuapp.com/student/api/lessonfiles/")
      .then((result) => {
        return result.json();
      })
      .then((jsonResult) => {
        setLoading(false);
        console.log(jsonResult[1]);
        SetGrammerMap(jsonResult[1]);
      });
    // const fetchData = async () => {
    //   const response = await fetch("https://jsonplaceholder.ir/posts/1/");
    //   const data = await response.json();
    //   console.log(data.body);
    //   SetGrammerMap(data.body);
    // };
  };

  return (
    <div>
      <Tolbar />
      <div className="GrammersItem">
        <MDBRow className="row-cols-1 row-cols-md-5 g-4">
          <MDBCol>
            <MDBCard className="h-100" onClick={() => handleClick()}>
              <MDBCardImage src="https://mdbootstrap.com/img/new/standard/city/042.webp" alt="..." position="top" />
              <MDBCardBody>
                <MDBCardTitle>اسم ها</MDBCardTitle>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard className="h-100">
              <MDBCardImage src="https://mdbootstrap.com/img/new/standard/city/043.webp" alt="..." position="top" />
              <MDBCardBody>
                <MDBCardTitle>زمان ها</MDBCardTitle>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard className="h-100">
              <MDBCardImage src="https://mdbootstrap.com/img/new/standard/city/044.webp" alt="..." position="top" />
              <MDBCardBody>
                <MDBCardTitle>افعال</MDBCardTitle>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard className="h-100">
              <MDBCardImage src="https://mdbootstrap.com/img/new/standard/city/041.webp" alt="..." position="top" />
              <MDBCardBody>
                <MDBCardTitle>ضمایر</MDBCardTitle>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard className="h-100">
              <MDBCardImage src="https://mdbootstrap.com/img/new/standard/city/041.webp" alt="..." position="top" />
              <MDBCardBody>
                <MDBCardTitle>قیدها</MDBCardTitle>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </div>
      <div className="show">{grammerMap && <GrammerDetais gram={grammerMap} />}</div>;
    </div>
  );
};

export default Grammer;
